// 门禁
import Log from '../view/log'
import diDingNav from '../components/common/di-ding/pages/nav'
import diDingCenter from '../components/common/di-ding/pages/center'
import diDingCreate from '../components/common/di-ding/pages/create'
import diDingCurrent from '../components/common/di-ding/pages/current'
import diDingModify from '../components/common/di-ding/pages/modify'
import accessOverView from '../view/AccessCtrl/accessOverView/accessOverView'
import accessCtrlDeviceManagementCenter from '../view/AccessCtrl/device-management/center'
import addDevice from '../view/AccessCtrl/device-management/add-device'
import currentDevice from '../view/AccessCtrl/device-management/current-device'
import modifyDevice from '../view/AccessCtrl/device-management/modify-device'

export default [
    /* *********
  门禁
  ********* */
    {
        path: '/access-control/access_over_view',
        name: 'access-over-view',
        components: {
            default: diDingNav,
            a: accessOverView
        }
    },
    {
        path: '/access-control/device/center',
        name: 'accessCtrlDeviceManagementCenter',
        components: {
            default: diDingNav,
            a: accessCtrlDeviceManagementCenter
        }
    },
    {
        path: '/access-control/device/add',
        name: 'add-device',
        components: {
            default: diDingNav,
            a: addDevice
        }
    },
    {
        path: '/access-control/device/current/:id',
        name: 'current-device',
        components: {
            default: diDingNav,
            a: currentDevice
        }
    },
    {
        path: '/access-control/device/modify/:id',
        name: 'modify-device',
        components: {
            default: diDingNav,
            a: modifyDevice
        }
    },

    {
        path: '/:diName/center/',
        name: 'diDingCenter',
        components: {
            default: diDingNav,
            a: diDingCenter
        }
    },
    {
        path: '/:diName/create/',
        name: 'diDingCreate',
        components: {
            default: diDingNav,
            a: diDingCreate
        }
    },
    {
        path: '/:diName/current/:id/',
        name: 'diDingCurrent',
        components: {
            default: diDingNav,
            a: diDingCurrent
        }
    },
    {
        path: '/:diName/modify/:id/',
        name: 'diDingModify',
        components: {
            default: diDingNav,
            a: diDingModify
        }
    },

    // 智慧门禁操作日志
    {
        path: '/access_ctrl_log',
        name: 'access-ctrl-log',
        components: {
            default: diDingNav,
            a: Log
        },
    },
]


// WEBPACK FOOTER //
// ./src/router/AccessCtrl.js